// extracted by mini-css-extract-plugin
module.exports = {"content":"_3sjGa","video":"_2RcOX","video-text":"_1BNj3","text-one":"_3BmFg","text-two":"_2AC3g","red":"_1M3Pl"};